import JSONFormatter from 'json-formatter-js';

Hop.defineModule('renderJson', (root, parameters = {initialDepth: 1}) => {
    const rawJson = root.innerHTML;
    const json = JSON.parse(rawJson);
    const fmt = new JSONFormatter(json, parameters.initialDepth, {
        hoverPreviewEnabled: true,
        hoverPreviewArrayCount: 20,
        hoverPreviewFieldCount: 5,
        theme: '',
        animateOpen: false,
        animateClose: false,
    });

    root.innerHTML = '';
    root.appendChild(fmt.render());
    root.classList.remove('hidden');
});
